import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';
import { newsItems } from '../../../mocks/news';

export default function NewsDetailPage() {
  const [scrolled, setScrolled] = useState(false);
  const [searchParams] = useSearchParams();
  const newsId = searchParams.get('id');

  const newsItem = newsItems.find(item => item.id === newsId);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (!newsItem) {
    return (
      <div className="min-h-screen bg-white">
        <Header scrolled={scrolled} />
        <main className="pt-24 pb-20">
          <div className="max-w-[800px] mx-auto px-6 lg:px-12">
            <p className="text-center text-gray-600">ニュースが見つかりませんでした。</p>
            <div className="mt-8 text-center">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm font-medium text-black hover:text-gray-600 transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
                ホームに戻る
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Header scrolled={scrolled} />
      <main className="pt-24 pb-20">
        <div className="max-w-[800px] mx-auto px-6 lg:px-12">
          <div className="mb-8">
            <Link
              to="/news"
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-black transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              ニュース一覧に戻る
            </Link>
          </div>

          <article>
            <div className="mb-8">
              <time className="text-sm text-gray-500 font-medium">
                {newsItem.date}
              </time>
              <h1 className="text-3xl md:text-4xl font-bold mt-4 mb-6 tracking-tight">
                {newsItem.title}
              </h1>
              <div className="inline-block px-4 py-1.5 bg-gray-100 text-xs font-medium text-gray-700 rounded-full">
                {newsItem.category}
              </div>
            </div>

            <div className="prose prose-lg max-w-none">
              <div className="border-t border-gray-200 pt-8">
                <p className="text-base leading-relaxed text-gray-700 mb-6">
                  この度、ワンダークラフトカンパニー株式会社は、2026年2月1日に公式コーポレートサイトを開設いたしました。
                </p>
                
                <p className="text-base leading-relaxed text-gray-700 mb-6">
                  当社は「エンターテインメントの力で、世界中の人々に驚きと感動を届ける」というビジョンのもと、インターネットビジネスの企画・開発・運営を中心に事業を展開してまいります。
                </p>

                <p className="text-base leading-relaxed text-gray-700 mb-6">
                  今後も当サイトを通じて、事業活動や最新情報を随時発信してまいります。皆様のご支援とご協力を賜りますよう、何卒よろしくお願い申し上げます。
                </p>

                <div className="mt-12 p-6 bg-gray-50 rounded-lg">
                  <h3 className="text-lg font-bold mb-4">お問い合わせ</h3>
                  <p className="text-sm text-gray-700 mb-4">
                    本件に関するお問い合わせは、以下よりお願いいたします。
                  </p>
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 px-6 py-3 bg-black text-white text-sm font-medium rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap"
                  >
                    お問い合わせフォーム
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </article>
        </div>
      </main>
      <Footer />
    </div>
  );
}